import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { ReceiptsPage } from './pages/ReceiptsPage';
import { TaxDocumentsPage } from './pages/TaxDocumentsPage';
import { CashFlowPage } from './pages/CashFlowPage';
import { SettingsPage } from './pages/SettingsPage';

function App() {
    return (
        <AuthProvider>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                        path="/*"
                        element={
                            <ProtectedRoute>
                                <Layout>
                                    <Routes>
                                        <Route path="/" element={<DashboardPage />} />
                                        <Route path="/dashboard" element={<DashboardPage />} />
                                        <Route path="/invoices" element={<InvoicesPage />} />
                                        <Route path="/receipts" element={<ReceiptsPage />} />
                                        <Route path="/tax-documents" element={<TaxDocumentsPage />} />
                                        <Route path="/cash-flow" element={<CashFlowPage />} />
                                        <Route path="/settings" element={<SettingsPage />} />
                                    </Routes>
                                </Layout>
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </Box>
        </AuthProvider>
    );
}

export default App; 